import React, { useReducer, useEffect } from "react";

// Custom hook for useReducer with middleware
const useReducerWithMiddleware = (
  reducer,
  initialState,
  middleware = [],
  afterDispatchMiddleWare = [],
  additionalData
) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const currentRef = React.useRef();

  //const { user } = additionalData;

  //const userId = user.uid;

  // useEffect(() => {
  //   middleware.forEach((mw) => mw(dispatch));
  // }, [afterDispatchMiddleWare, state]);

  const middlewareDispatch = async (action) => {
    if (middleware.length > 0) {
      for (const middlewareFunction of middleware) {
        await middlewareFunction(action, state, additionalData);
      }
    }
    // Set the currentRef to the action.
    currentRef.current = action;

    //console.log("middlewareDispatch", action);
    dispatch(action);
  };

  useEffect(() => {
    const runAfterDispatchMiddleware = async (action) => {
      for (const middlewareFunction of afterDispatchMiddleWare) {
        try {
          await middlewareFunction(action, state, additionalData);
        } catch (error) {
          // Handle after dispatch middleware errors if needed
          console.error("After Dispatch Middleware error:", error);
        }
      }

      // Clear the currentRef
      currentRef.current = null;
    };

    if (!currentRef.current || !afterDispatchMiddleWare.length) {
      return;
    }
    //console.log("useEffect currentRef", currentRef.current);
    // Run after dispatch middleware
    runAfterDispatchMiddleware(currentRef.current);
  }, [afterDispatchMiddleWare, state, additionalData]);

  return [state, middlewareDispatch];
};

export default useReducerWithMiddleware;
